import { render, staticRenderFns } from "./asesor.vue?vue&type=template&id=28844a34&"
import script from "./asesor.vue?vue&type=script&lang=js&"
export * from "./asesor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports